import React from 'react';
import RegionalContacts from '../components/contact/RegionalContacts';
import ContactForm from '../components/contact/ContactForm';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white sm:text-5xl">
            Get in Touch
          </h1>
          <p className="mt-4 text-xl text-gray-600 dark:text-gray-300">
            We're here to help transform your digital presence
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <RegionalContacts />
          <ContactForm />
        </div>
      </div>
    </div>
  );
}